var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-slider',{attrs:{"disabled":"","label":"Disabled","value":"30"}}),_c('v-slider',{attrs:{"readonly":"","label":"Readonly","value":"30","hide-details":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }